import {pageInfo, initUpdate, editData, cancleOrder, exportData, selectTotalProfit, initPage} from './../api';
const orderSearch = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    deleteResp: null,
    initPageObj: null,
    initUpdateObj: null,
    carrierInfoObj: null,
    cancleObj: null,
    travelStatusObj: null,
    expensesAreasOptionObj: null,
    exportObj: null,
    totalProfitObj: null,
    orderUserNoObj: null
  },
  mutations: {

  },
  actions: {

  }
}
export default orderSearch



// WEBPACK FOOTER //
// ./src/page/zhubo/orderQuery/store/orderQuery.store.js